import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Avatar({ name = "", size = 36, color }) {
  const palette = [t.emerald, t.sky, t.amber, t.coral, t.purple, "#059669"];
  const bg = color || palette[Math.abs((name.charCodeAt(0) || 65) - 65) % palette.length];
  const initials = name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: `linear-gradient(135deg, ${bg}, ${bg}cc)`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.35, fontWeight: 700, color: "#fff",
      fontFamily: font.body, flexShrink: 0, letterSpacing: "0.02em",
      boxShadow: `0 0 0 2px ${bg}22`,
    }}>{initials}</div>
  );
}

export function StatusDot({ status = "active" }) {
  const colors = { active: t.emerald, away: t.amber, offline: "#d1d5db", busy: t.coral };
  const c = colors[status] || "#d1d5db";
  return (
    <span style={{
      display: "inline-block", width: 8, height: 8, borderRadius: "50%",
      background: c, border: "2px solid #fff",
      animation: status === "active" ? "pulseDot 2.4s infinite" : "none",
      flexShrink: 0,
    }} />
  );
}
